<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

  // Code for hiding elements according to region

console.log("region " + pageRegion);
console.log("lang " + pageLang);

var subscribeBanner = document.getElementById('subscribe-container');

if(pageRegion == "GB") {
  $('#shopify-section-footer > footer > div > div > div > div:nth-child(4) > div > div > ul > li:nth-child(1)').hide();
  if (window.location.pathname === '/en-uk/pages/where-to-buy') {
    window.location.href = 'https://angelcarebaby.com/en-uk';
}
  subscribeBanner.style.display = "block";
  const menuItems = document.querySelectorAll('ul.list-menu li.menu-lv-item'); 
    menuItems[5].style.display = 'none';
}

if(pageRegion == "FR" && pageLang == "fr"){
  const menuItems = document.querySelectorAll('ul.list-menu li.menu-lv-item'); 
  menuItems[3].style.display = 'none';
}


let monitoringLink = $('[href*="/collections/monitoring"]');

let sleepingLink = $('[href*="/collections/sleeping"]');

let changingLink = $('[href*="/collections/changing"]');

let modernSlaveryActLink = $('[href*="/modern-slavery-act-2023"]');

let batterySafetyNoticeLink = $('[href*="/battery-safety-notice"]');

if(pageRegion == "CA" && pageLang == "fr") {
  document.querySelector('#shopify-section-footer > footer > div > div > div > div:nth-child(2) > div > div > ul > li:nth-child(6)').style.display = 'none';
}



if(pageRegion == "DE" ||  pageRegion == "FR" || pageRegion == "US" || pageRegion == "CA" ) {
  if(modernSlaveryActLink){
    modernSlaveryActLink.remove();
  }
}

if(pageRegion == "FR" || pageRegion == "DE") {
  $('#monitoring-custom-text').hide();

  if(sleepingLink){
    sleepingLink.remove();
  }

}

if(pageRegion == "FR") {
    $('.faqs-row .faqs-item:eq(8)').show();
}



if(pageRegion == "US" || pageRegion == "CA") {
  if(monitoringLink){
    monitoringLink.remove();
  }

  if(changingLink){
    changingLink.remove();
  }

  if(batterySafetyNoticeLink){
    batterySafetyNoticeLink.remove();
  }
}


if(pageRegion == "DE") {

  let pailsHeading = document.querySelector('.pails-heading')

  if(pailsHeading){
    document.querySelector('.pails-heading').classList.add('german-pails-heading');
  }
}


let productInfoLinkFooter = $('[href*="https://angelcareuk.zendesk.com/hc/en-gb/categories/16940034941463-Product-Manuals-Conformity-Documentation"]')

if(productInfoLinkFooter){
  productInfoLinkFooter.attr('target','_blank'); 
} 


if(pageRegion == "DE" || pageRegion == "FR") {

  let comparisonTable = document.querySelector('.comparsion-table');

  if(comparisonTable){
    document.querySelector('.comparsion-table').style.display = "block"
  }
}

 const h2Element = document.querySelector('.comparison-content h2');

if(h2Element) {
  
  if (h2Element.textContent.trim() !== '') {
    console.log("HAS TEXT");
      document.querySelector('.comparsion-table').style.display = "block"
  } else {
    console.log("NO TEXT");
      document.querySelector('.comparsion-table').classList.add("hideSection");
  }
  
}







<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->